var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMin = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "arrow-down-left-and-arrow-up-right-to-center"
}, /*#__PURE__*/React.createElement("path", {
  id: "Primary",
  d: "M17.2809 3.78126C17.5746 3.48751 17.5746 3.01251 17.2809 2.72189C16.9871 2.43126 16.5121 2.42814 16.2215 2.72189L12.0027 6.94064L11.9996 4.25001C11.9996 3.83439 11.6652 3.50001 11.2496 3.50001C10.834 3.50001 10.4996 3.83439 10.4996 4.25001V8.75001C10.4996 9.16564 10.834 9.50001 11.2496 9.50001H15.7496C16.1652 9.50001 16.4996 9.16564 16.4996 8.75001C16.4996 8.33439 16.1652 8.00001 15.7496 8.00001H13.059L17.2809 3.78126ZM2.71836 16.2188C2.42461 16.5125 2.42461 16.9875 2.71836 17.2781C3.01211 17.5688 3.48711 17.5719 3.77773 17.2781L7.99648 13.0594V15.75C7.99648 16.1656 8.33086 16.5 8.74648 16.5C9.16211 16.5 9.49648 16.1656 9.49648 15.75V11.25C9.49648 10.8344 9.16211 10.5 8.74648 10.5H4.24961C3.83398 10.5 3.49961 10.8344 3.49961 11.25C3.49961 11.6656 3.83398 12 4.24961 12H6.94023L2.71836 16.2188Z",
  fill: "white"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cb94f9df7577502721dbcfa80c48aebb.svg";